
export const activityCycle_number=[
    {
        "value":"每天",
        "text" :"每天"
    },
    {
        "value":"星期一",
        "text" :"星期一"
    },
    {
        "value":"星期二",
        "text" :"星期二"
    },
    {
        "value":"星期三",
        "text" :"星期三"
    },
    {
        "value":"星期四",
        "text" :"星期四"
    },
    {
        "value":"星期五",
        "text" :"星期五"
    },
    {
        "value":"星期六",
        "text" :"星期六"
    },
    {
        "value":"星期天",
        "text" :"星期天"
    },
]
export const productList=[
    {
        "wechatName": "本地测试",
        "wechatId": "NAVTEST",
        "activityName": "产品促销",
        "modeID": "modeID",
        "imgUrl": require("/src/image/3.jpg"),
        "activityRemarks": "产品促销消息推送"
    },
    {
        "wechatName": "本地测试",
        "wechatId": "NAVTEST",
        "activityName": "生日问候",
        "modeID": "modeID2",
        "imgUrl": require("/src/image/2.jpg"),
        "activityRemarks": "生日快乐,愿你常与开心做伴"
    },
    {
        "wechatName": "本地测试",
        "wechatId": "NAVTEST",
        "activityName": "生日问候",
        "modeID": "modeID3",
        "imgUrl": require("/src/image/2.jpg"),
        "activityRemarks": "生日快乐,愿你常与开心做伴"
    },
    {
        "wechatName": "本地测试",
        "wechatId": "NAVTEST",
        "activityName": "生日问候",
        "modeID": "modeID4",
        "imgUrl": require("/src/image/2.jpg"),
        "activityRemarks": "生日快乐,愿你常与开心做伴"
    },
    {
        "wechatName": "本地测试",
        "wechatId": "NAVTEST",
        "activityName": "生日问候",
        "modeID": "modeID5",
        "imgUrl": require("/src/image/2.jpg"),
        "activityRemarks": "生日快乐,愿你常与开心做伴"
    },

];